if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.thumbs = this.querySelectorAll('[thumb]');

        this.querySelector('[total]').innerHTML = this.thumbs.length;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.showActiveMedia(thumb.getAttribute('data-media-id'));
          });
        });

        this.querySelectorAll('[prev]').forEach((prevBtn) => prevBtn.addEventListener('click', () => {
          this.prev();
        }));

        this.querySelectorAll('[next]').forEach((prevBtn) => prevBtn.addEventListener('click', () => {
          this.next();
        }));

        var startX;
        var startY;
        var distX;
        var distY;
        var threshold = 50; // required min distance traveled to be considered swipe
        var allowedTime = 1000; // maximum time allowed to travel that distance
        var elapsedTime;
        var startTime;

        var swipeArea = document.querySelector('[swipe-area]');
        

        swipeArea.addEventListener('touchstart', (e) => {
            console.log("🚀 ~ ProductModal ~ swipeArea.addEventListener ~ e:", e);
            var touchobj = e.changedTouches[0];
            distX = 0;
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime(); // record time when finger first makes contact with surface
            e.preventDefault();
        }, false);

        swipeArea.addEventListener('touchend', (e) => {
            console.log("🚀 ~ ProductModal ~ swipeArea.addEventListener ~ e:", e);
            var touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
            distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
            elapsedTime = new Date().getTime() - startTime; // get time elapsed
            var swipeRightBol = (elapsedTime <= allowedTime && distX >= threshold && Math.abs(distY) <= 100);
            var swipeLeftBol = (elapsedTime <= allowedTime && distX <= -threshold && Math.abs(distY) <= 100);
            if (swipeRightBol) {
                console.log('Swiped right');
                this.prev();
            } else if (swipeLeftBol) {
                console.log('Swiped left');
                this.next();
            }
            e.preventDefault();
        }, false);
      }

      hide() {
        super.hide();
      }

      prev() {
        const activeThumb = this.querySelector('[thumb][active-media]');

        const prevThumb = activeThumb.previousElementSibling;

        if (prevThumb) {
          prevThumb.click();
        } else {
          this.thumbs[this.thumbs.length - 1].click();
        }
      }

      next() {
        const activeThumb = this.querySelector('[thumb][active-media]');

        const nextThumb = activeThumb.nextElementSibling;

        if (nextThumb) {
          nextThumb.click();
        } else {
          this.thumbs[0].click();
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(this.openedBy.getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId) {

        const currentIndex = Number(this.querySelector('[current-index]').innerHTML);
        
        
        const newIndex = Array.from(this.thumbs).findIndex((element) => {
          return element.getAttribute('data-media-id') === mediaId
        }) + 1;

        const mainContainer = this.querySelector('div[main]');

        if (newIndex > currentIndex) {
          mainContainer.removeAttribute('backwards');
          mainContainer.setAttribute('forwards', '');
        } else {
          mainContainer.removeAttribute('forwards');
          mainContainer.setAttribute('backwards', '');
        }


        // if (newIndex === 1) {
        //   mainContainer.setAttribute('start', '');
        // } else {
        //   mainContainer.removeAttribute('start');
        // }

        // if (newIndex === this.thumbs.length) {
        //   mainContainer.setAttribute('end', '');
        // } else {
        //   mainContainer.removeAttribute('end');
        // }

        this.querySelector('[current-index]').innerHTML = newIndex;

        // console.log("🚀 ~ ProductModal ~ showActiveMedia ~ activeMedia:", activeMedia);
        // const mainContainer = this.querySelector('div[main]');

        // // const needCleanup = mainContainer.querySelector('[need-clean-up]');

        // // if (needCleanup) {
        // //   mainContainer.removeChild(needCleanup);
        // // }

        // const currentActive = mainContainer.querySelector('[active]');
        // const newActive = activeMedia.cloneNode(true);

        // newActive.setAttribute('active','');

        // if (currentActive) {
        //   currentActive.removeAttribute('active');
  
        //   // currentActive.setAttribute('need-clean-up','');
        // }

        // mainContainer.appendChild(newActive);

        const currentActiveMedias = this.querySelectorAll('[active-media]');

        currentActiveMedias.forEach((media) => {
          media.removeAttribute('active-media');
        });

        const newActiveMedias = this.querySelectorAll(`[data-media-id="${mediaId}"]`);

        newActiveMedias.forEach((media) => {
          media.setAttribute('active-media', '');
        });
      }
    }
  );
}
